import { Markdown } from '@/ui';
import { Section } from './Section';
import { ITextSectionEntry } from '../../../../contentful';
import { MarkdownRenderContextProvider } from '../../../../components/common/markdown';

export interface ITextSectionsProps {
	section: ITextSectionEntry;
}

export function TextSection({ section }: ITextSectionsProps) {
	return (
		<Section>
			<MarkdownRenderContextProvider>
				<Markdown source={section.fields.body} />
			</MarkdownRenderContextProvider>
		</Section>
	);
}
